import { selectOrg, useAuthStore } from '@client/stores/AuthStore';

type Org = NonNullable<ReturnType<typeof selectOrg>>;

export function useOrg<T extends boolean = true>(options?: {
    throwOnUndefined?: T;
}): T extends true ? Org : Org | undefined {
    const org = useAuthStore(selectOrg);

    if (!org && options?.throwOnUndefined !== false) {
        throw new Error('useOrg: Org is undefined.');
    }

    return org!;
}
